import { http } from '@/core/helpers/axiosHelper';

export class PerformanceService {
   async postContractPerformance(contractId: number, body: any) {
      return await http.post(`/contracts/${contractId}/performances`, body).then((response) => response.data);
   }
   async putContractPerformance(contractId: number, performanceId: number, body: any) {
      return await http.put(`/contracts/${contractId}/performances/${performanceId}`, body).then((response) => response.data);
   }
   async deleteContractPerformance(contractId: number, performanceId: number) {
      return await http.delete(`/contracts/${contractId}/performances/${performanceId}`).then((response) => response.data);
   }
}
